import { Rest, Endpoint } from 'aurelia-api';
import { autoinject, inject, LogManager } from 'aurelia-framework';
import { Logger } from 'aurelia-logging';
import { ControllerValidateResult, ValidationController, ValidationControllerFactory } from 'aurelia-validation';
import { BootstrapFormRenderer } from '../../services/bootstrap-form-renderer';
import { DialogController } from 'aurelia-dialog';
import { Helpers } from '../../services/helpers';
import { UserCreateViewModel } from '../../models/usercreateview-model';

@autoinject
export class UsersModalCreate {
	private validationController: ValidationController | null = null;
	private logger: Logger = LogManager.getLogger('USERSMODALCREATE');
    public model: UserCreateViewModel = null;

    private saveDisabled: boolean = false;

	constructor(
		@inject(Endpoint.of('api'))
		private api: Rest,
		private validationControllerFactory: ValidationControllerFactory,
		private dialogController: DialogController) {
			this.validationController = validationControllerFactory.createForCurrentScope();
			this.validationController.addRenderer(new BootstrapFormRenderer());
	}

    async activate() {
        this.logger.debug("activate");
        this.model = new UserCreateViewModel();
    }

	async save() {
		this.logger.debug('save');
        this.saveDisabled = true;

		const validation: ControllerValidateResult = await this.validationController.validate();

        if (validation.valid !== false) {
			await this.api.create('/User/Insert', this.model)
				.then((data: UserCreateViewModel) => {
					this.saveDisabled = false;
                    this.logger.debug('Success save: ', data);
					this.dialogController.ok(data);
				}).catch(async (err) => {
                    this.saveDisabled = false;
                    this.logger.debug('Error blabla save: ', err);
                    await Helpers.ParseValidationError(err, this.validationController, this.model);
                });
		} else {
			this.saveDisabled = false;
		}
	}

	async cancel() {
		await this.dialogController.cancel();
	}
}